<template>
  <div>
    <modalDefaultBig :showModal="showModal" @close="close()" @confirm="confirm()" modalText="全服消费排行" :showCancel="false"
      :showConfirm="false">
      <template #dialogContent>
        <div class="tab-box">
          <div @click="changeTab('todayFightRanking')" :class="[curTab == 'todayFightRanking' ? 'sel' : '']"
            class="tab-item">
            今日
          </div>
          <div @click="changeTab('yesterdayFightRanking')" :class="[curTab == 'yesterdayFightRanking' ? 'sel' : '']"
            class="tab-item">
            昨日
          </div>
        </div>
        <!-- <div class="text-row"></div> -->
        <div class="rank-table-wrap">
          <div class="rank-table-header">
            <div class="user-info">排名</div>
            <div class="user-info">会员</div>
            <div class="user-info">消费总和</div>
          </div>
          <div class="rank-table-list">
            <div class="rank-item" v-for="(item, index) in rankLists[curTab]" :key="index">
              <div class="user-info">
                <div class="rank-index">
                  <div v-if="index == 0" class="rank-index-img one-img">{{ index + 1 }}</div>
                  <div v-else-if="index == 1" class="rank-index-img two-img">{{ index + 1 }}</div>
                  <div v-else-if="index == 2" class="rank-index-img three-img">{{ index + 1 }}</div>
                  <div v-else class="rank-index-img">{{ index + 1 }}</div>
                </div>
                <div class="user-avatar-box">
                  <img :src="`${$getFullPath(item.avatar)}`" alt="" mode="aspectFit" />
                  <!-- <img :src="item.avatar | fullPath" alt="" mode="aspectFit" /> -->
                  <div class="nickname text-ellipsis">{{ item.nickName }}</div>
                </div>
                <div class="nickname text-ellipsis nickname-box">
                  {{ Math.abs(item.totalRecharge) || 0 }}
                </div>
              </div>
            </div>

            <div v-if="rankLists[curTab].length == 0" style="width: 100%; margin-top: 30%">
              <div class="no-data">
                <div class="empty-box-new"></div>
                <div class="tip-text">暂无用户消费</div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="cur-rank-box">
          <div class="rank-index"> {{ rank }} </div>
          <div class="user-info">
            <div class="user-avatar">
              <image
                :src="
                  user.avatarUrl
                    ? user.avatarUrl
                    : '../../assets/default-header.png'
                "
                alt=""
                mode="aspectFit"
              ></image>
              <div class="avatar-bg"></div>
            </div>
            <div class="nickname text-ellipsis">{{ user.nickName }}</div>
          </div>
          <div class="prod-price">
            <div class="tips">{{ rankInfo }}</div>
          </div>
        </div> -->
      </template>
      <!-- <template #bottomTab>
        <div @click="changeTab('todayFightRanking')" :class="[curTab == 'todayFightRanking' ? 'sel' : '']"
          class="tab-item">
          今日
        </div>
        <div @click="changeTab('yesterdayFightRanking')" :class="[curTab == 'yesterdayFightRanking' ? 'sel' : '']"
          class="tab-item">
          昨日
        </div>
      </template> -->
    </modalDefaultBig>
  </div>
</template>
<script>
import { rechargeRanking } from "@/api/index";
import modalDefaultBig from "@/components/common/modalDefaultBig.vue";
export default {
  name: "modalBoxDetail",
  components: {
    modalDefaultBig,
  },
  data() {
    return {
      curTab: 0,
      rankLists: [],
    };
  },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    showModal(val) {
      if (val) {
        this.curTab = "todayFightRanking";
        this.getRank();
      }
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
    confirm() {
      this.$emit("confirm");
    },
    changeTab(type) {
      this.curTab = type;
    },
    // 获取排行榜
    getRank() {
      rechargeRanking().then((res) => {
        if (res.data.code == 200) {
          const list = res.data.data;
          this.rankLists = list;
          // this.isranklist = true;
          // if (this.type == 0) {
          //   this.list = res.data.data.todayFightRanking;
          // } if (this.type == 1) {
          //   this.list = res.data.data.yesterdayFightRanking;

          // }
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.tab-box {
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: 500;
  font-size: 3.33 * 4.2px;
  color: #FFFFFF;
  line-height: 3.81 * 4.2px;
  text-align: center;
  font-style: normal;
  text-transform: none;

  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  margin: 4.76 * 4.2px;

  @media only screen and (max-width: 430px) {
    font-size: 3.33vw;
    line-height: 3.81vw;
    margin: 4.76vw;
  }
}

.tab-box .tab-item {
  width: 18.26 * 4.2px;
  height: 7.28 * 4.2px;
  background: url("../../assets/image3/share/notSelectedBack.png") no-repeat 0 0;
  background-size: 18.26 * 4.2px 7.28 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  margin-right: 1 * 4.2px;
  color: #cccccc;

  @media only screen and (max-width: 430px) {
    width: 18.26vw;
    height: 7.28vw;
    background-size: 18.26vw 7.28vw;
    margin-right: 1vw;
  }
}

.tab-box .tab-item.sel {
  background: url("../../assets/image3/share/selectBack.png") no-repeat 0 0;
  background-size: 18.26 * 4.2px 7.28 * 4.2px;
  color: #ffffff;

  @media only screen and (max-width: 430px) {
    background-size: 18.26vw 7.28vw;
  }
}

.text-row {
  width: 100 * 4.2px;
  height: 3.2 * 4.2px;
  line-height: 3.2 * 4.2px;
  background-size: 64 * 4.2px 0.67 * 4.2px;
  margin: 2.27 * 4.2px auto 2.27 * 4.2px auto;
}

.top-box {
  width: 100 * 4.2px;
  height: 25.33 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: relative;
  z-index: 5;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  margin-bottom: -0.67 * 4.2px;
}

.top-box .img-1 {
  width: 66.67 * 4.2px;
  height: 25.33 * 4.2px;
}

.top-box .img-2 {
  position: absolute;
  width: 22.27 * 4.2px;
  height: 22.27 * 4.2px;
  left: 50%;
  margin-left: -22.13 * 4.2px;
  bottom: 0;
}

.rank-table-wrap {
  height: 93.33 * 4.2px;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin: 0 4.27 * 4.2px;
  position: relative;


  @media only screen and (max-width: 430px) {
    height: 93.33vw;
    margin: 0 4.27vw;
  }
}

.rank-table-wrap .rank-table-header {
  height: 9 * 4.2px;
  line-height: 9 * 4.2px;
  background: #262B66;
  color: #a6bbff;
  font-size: 3.33 * 4.2px;
  font-weight: 700;
  border-radius: 5PX;
  display: flex;
  align-items: center;
  padding-left: 10px;

  @media only screen and (max-width: 430px) {
    height: 9vw;
    line-height: 9vw;
    font-size: 3.33vw;
  }
}

.rank-table-wrap .rank-table-header .user-info {
  width: calc(80% / 2);
  text-align: left;
}
.rank-table-wrap .rank-table-header .user-info:first-child {
  width: 20%;
}

.rank-table-wrap .rank-table-list .rank-index .one-img {
  background: url("../../assets/image3/home/rankingOne.png") no-repeat 0 0;
}

.rank-table-wrap .rank-table-list .rank-index .two-img {
  background: url("../../assets/image3/home/rankingTwo.png") no-repeat 0 0;
}

.rank-table-wrap .rank-table-list .rank-index .three-img {
  background: url("../../assets/image3/home/rankingThree.png") no-repeat 0 0;
}

.rank-table-wrap .rank-table-list .rank-index .rank-index-img {
  width: 8.33 * 4.2px;
  height: 5.95 * 4.2px;
  background-size: 100% 100%;
  line-height: 5.95 * 4.2px;
  text-align: center;
  font-size: 2.86 * 4.2px;

  @media only screen and (max-width: 430px) {
    width: 8.33vw;
    height: 5.95vw;
    line-height: 5.95vw;
    font-size: 2.86vw;
  }
}

.rank-table-wrap .yesterday-rank-h {
  background: url("../../assets/images/header-bg2.png") no-repeat 0 0;
  background-size: 91.47 * 4.2px 5.33 * 4.2px;
}

.rank-table-wrap .yesterday-rank-h .user-info {
  width: 32 * 4.2px;
}

.rank-table-wrap .yesterday-rank-h .price {
  width: 37.33 * 4.2px;
  text-align: center;
}

.rank-table-wrap .rank-index {
  width: 17.73 * 4.2px;
  height: 8.27 * 4.2px;
  line-height: 8.27 * 4.2px;
  margin-right: 1.33 * 4.2px;
}

.rank-table-wrap .rank-index .first-img {
  width: 17.73 * 4.2px;
  height: 7.6 * 4.2px;
}

.rank-table-wrap .rank-index .second-img,
.rank-table-wrap .rank-index .third-img {
  width: 12.13 * 4.2px;
  height: 7.6 * 4.2px;
}

.rank-table-wrap .user-avatar-box {
  // width: 33%;
  text-align: left;
  // margin-left: 3 * 4.2px;
  display: flex;
  align-items: center;
  // justify-content: center;
}

.rank-table-wrap .user-avatar-box img {
  width: 5.95 * 4.2px;
  height: 5.95 * 4.2px;
  border-radius: 50px;

  @media only screen and (max-width: 430px) {
    width: 5.95vw;
    height: 5.95vw;
    margin-right: 1vw;
  }
}

.rank-table-wrap .nickname {
  // width: 33%;
  height: 8.8 * 4.2px;
  line-height: 8.8 * 4.2px;
  font-size: 3.33 * 4.2px;
  text-align: left;

  @media only screen and (max-width: 430px) {
    width: 28.27vw;
    height: 8.8vw;
    line-height: 8.8vw;
    font-size: 3.33vw;
    text-align: left;
  }
}

.rank-table-wrap .nickname-box {
  // width: 33%;
  text-align: left;
  // margin-left: 3 * 4.2px;
}

.rank-table-wrap .user-avatar {
  width: 6.4 * 4.2px;
  height: 6.4 * 4.2px;
  -webkit-border-radius: 3.2 * 4.2px;
  border-radius: 3.2 * 4.2px;
  position: relative;
  margin: -4.094px 10.626px 3.906px 0px;
}

.rank-table-wrap .user-avatar img {
  width: 6.4 * 4.2px;
  height: 6.4 * 4.2px;
  -webkit-border-radius: 3.2 * 4.2px;
  border-radius: 3.2 * 4.2px;
}

.rank-table-wrap .user-avatar .avatar-bg {
  width: 6.67 * 4.2px;
  height: 6.67 * 4.2px;
  overflow: hidden;
  background: url("../../assets/images/k22.png") no-repeat 0 0;
  background-size: 6.67 * 4.2px 6.67 * 4.2px;
  position: absolute;
  left: -1px;
  top: 5px;
  z-index: 5;
}

.rank-table-wrap .yesterday-rank-i .user-info {
  width: 52.4 * 4.2px;
}

.rank-table-wrap .yesterday-rank-i .user-info .rank-index {
  width: 17.73 * 4.2px;
}

.all-rank-dialog .rank-table-wrap .yesterday-rank-i .user-info .rank-index .second-img,
.all-rank-dialog .rank-table-wrap .yesterday-rank-i .user-info .rank-index .third-img {
  margin: 0 2.8 * 4.2px;
}

.all-rank-dialog .rank-table-wrap .yesterday-rank-i .user-info .rank-index div {
  width: 17.73 * 4.2px;
}

.rank-table-wrap .yesterday-rank-i .user-info .user-avatar {
  margin-left: 2.67 * 4.2px;
}

.rank-table-wrap .yesterday-rank-i .price {
  margin-left: 1.33 * 4.2px;
  width: 37.73 * 4.2px;
  line-height: 8.27 * 4.2px;
  text-align: center;
  color: #ffe3c2;
}

.rank-table-wrap .rank-table-list {
  height: 88 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto;

  @media only screen and (max-width: 430px) {
    height: 88vw;
  }
}

.rank-table-wrap .rank-table-list .rank-item {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  // display: flex;
 
  margin-top: 2.4 * 4.2px;
  position: relative;
  padding-left: 10px;

  @media only screen and (max-width: 430px) {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    margin-top: 2.4vw;
    position: relative;
  }
}

.rank-table-wrap .rank-table-list .user-info {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  // display: flex;
  // justify-content: space-between;
  border-bottom: 1px solid rgba(3, 46, 105, 0.43);
  align-items: center;
  display:grid;
  grid-template-columns: 20% 1fr 1fr;   

  @media only screen and (max-width: 430px) {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
  }
}

.rank-table-wrap .rank-table-list .rank-index {
  // width: calc(100% / 3);
  text-align: left;
}

.rank-table-wrap .rank-table-list .prod-price {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  height: 8.8 * 4.2px;
  line-height: 8.8 * 4.2px;
}

.explain-content {
  width: 91.47 * 4.2px;
  height: 109.33 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin: 0 4.27 * 4.2px;
  position: relative;
}

.explain-content .rank-table {
  width: 91.47 * 4.2px;
  height: 93.33 * 4.2px;
}

.explain-content .rank-table .table-head {
  width: 91.47 * 4.2px;
  height: 5.33 * 4.2px;
  background: url("../../assets/images/header-bg-2.png") no-repeat 0 0;
  background-size: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  font-size: 3.33 * 4.2px;
  font-weight: 700;
  text-align: center;
  line-height: 5.33 * 4.2px;
  color: #a6bbff;
}

.explain-content .rank-table .table-head .head-index {
  height: 100%;
  width: 58%;
}

.explain-content .rank-table .table-head .head-price {
  height: 100%;
  width: 41%;
}

.explain-content .rank-table .table-body {
  width: 91.47 * 4.2px;
  height: 88 * 4.2px;
  overflow: hidden;
  overflow-y: scroll;
}

.explain-content .rank-table .table-body .table-item {
  width: 91.47 * 4.2px;
  height: 9.73 * 4.2px;
  line-height: 9.73 * 4.2px;
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.all-rank-dialog .explain-content .rank-table .table-body .table-item .item-index {
  height: 100%;
  width: 58%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.all-rank-dialog .explain-content .rank-table .table-body .table-item .item-index .index-icon {
  width: 17.73 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  margin-right: 2.67 * 4.2px;
}

.all-rank-dialog .explain-content .rank-table .table-body .table-item .item-index .index-icon .first-img {
  width: 17.73 * 4.2px;
  height: 7.6 * 4.2px;
}

.all-rank-dialog .explain-content .rank-table .table-body .table-item .item-index .index-icon .second-img,
.all-rank-dialog .explain-content .rank-table .table-body .table-item .item-index .index-icon .third-img {
  width: 12.13 * 4.2px;
  height: 7.6 * 4.2px;
}

.all-rank-dialog .explain-content .rank-table .table-body .table-item .item-index .index-icon .ranking {
  font-size: 2.67 * 4.2px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  color: #ffffff;
}

.all-rank-dialog .explain-content .rank-table .table-body .table-item .item-price {
  height: 100%;
  width: 41%;
  text-align: center;
  font-size: 2.67 * 4.2px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  color: #ffe3c2;
}

.explain-content .rank-table .table-body .table-item:after {
  content: "";
  display: block;
  width: 91.47 * 4.2px;
  height: 0.4 * 4.2px;
  background: url("../../assets/images/line16.png") no-repeat 0 0;
  background-size: 91.47 * 4.2px 0.4 * 4.2px;
  position: absolute;
  left: 0;
  bottom: 0;
}

.explain-content .rank-footer {
  padding-top: 2.67 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  width: 91.47 * 4.2px;
  height: 17.33 * 4.2px;
  font-size: 3.33 * 4.2px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: center;
  color: #ced0ff;
}

.cur-rank-box {
  width: 95.07 * 4.2px;
  height: 11.33 * 4.2px;
  background: url("../../assets/images/cur_rank_bg.png") no-repeat 0 0;
  background-size: 95.07 * 4.2px 11.33 * 4.2px;
  margin: 6.67 * 4.2px 4.27 * 4.2px 2.67 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.cur-rank-box .rank-index {
  width: 14.67 * 4.2px;
  height: 8.27 * 4.2px;
  line-height: 8.27 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
  margin-right: 1.33 * 4.2px;
  font-size: 3.33 * 4.2px;
}

.cur-rank-box .user-info {
  width: 38.67 * 4.2px;
  height: 8.27 * 4.2px;
  line-height: 8.27 * 4.2px;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.cur-rank-box .user-avatar {
  width: 6.4 * 4.2px;
  height: 6.4 * 4.2px;
  -webkit-border-radius: 3.2 * 4.2px;
  border-radius: 3.2 * 4.2px;
  position: relative;
  margin: 0.93 * 4.2px 2.53 * 4.2px 0.93 * 4.2px 5.33 * 4.2px;
}

.cur-rank-box .user-avatar img {
  width: 6.4 * 4.2px;
  height: 6.4 * 4.2px;
  -webkit-border-radius: 3.2 * 4.2px;
  border-radius: 3.2 * 4.2px;
}

.cur-rank-box .user-avatar .avatar-bg {
  width: 6.4 * 4.2px;
  height: 6.4 * 4.2px;
  overflow: hidden;
  background: url("../../assets/images/k22.png") no-repeat 0 0;
  background-size: 6.4 * 4.2px 6.4 * 4.2px;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 5;
}

.cur-rank-box .nickname {
  // width: 28.27 * 4.2px;
  height: 8.8 * 4.2px;
  line-height: 8.8 * 4.2px;
  font-size: 3.33 * 4.2px;
  text-align: left;
}

.cur-rank-box .prod-price {
  width: 37.33 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: right;
  padding-right: 6.67 * 4.2px;
  margin-left: 1.33 * 4.2px;
}

.cur-rank-box .prod-price .tips {
  font-size: 2.67 * 4.2px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  color: #b3c6ff;
  white-space: nowrap;
}

.cur-rank-box .prod-price .price {
  font-size: 3.33 * 4.2px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  color: #ffe3c2;
}

.date-filter {
  width: 91.47 * 4.2px;
  height: 9.87 * 4.2px;
  margin: 0 4.27 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  position: relative;
}

.date-filter .filter-item {
  position: absolute;
  top: -1.33 * 4.2px;
  z-index: 1;
  width: 28.13 * 4.2px;
  height: 9.87 * 4.2px;
  text-align: center;
  background: url("../../assets/images/filter_item_sel.png") no-repeat 0 center;
  background-size: 27.2 * 4.2px 8.93 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  font-size: 4.4 * 4.2px;
  font-weight: 700;
  color: #ffffff;
}

.date-filter .filter-item.active {
  background: url("../../assets/images/filter_item.png") no-repeat 0 center;
  background-size: 28.13 * 4.2px 9.87 * 4.2px;
}

.date-filter .filter-item image {
  width: 7.47 * 4.2px;
  height: 4.13 * 4.2px;
}

.date-filter .filter-item:nth-child(1) {
  left: 0;
}

.date-filter .filter-item:nth-child(3) {
  right: 0;
}

@media only screen and (max-width: 430px) {
  .text-row {
    width: 100vw;
    height: 3.2vw;
    line-height: 3.2vw;
    background-size: 64vw 0.67vw;
    margin: 2.27vw auto 2.27vw auto;
  }

  .top-box {
    width: 100vw;
    height: 25.33vw;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    position: relative;
    z-index: 5;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    margin-bottom: -0.67vw;
  }

  .top-box .img-1 {
    width: 66.67vw;
    height: 25.33vw;
  }

  .top-box .img-2 {
    position: absolute;
    width: 22.27vw;
    height: 22.27vw;
    left: 50%;
    margin-left: -22.13vw;
    bottom: 0;
  }

  .rank-table-wrap .yesterday-rank-h {
    background: url("../../assets/images/header-bg2.png") no-repeat 0 0;
    background-size: 91.47vw 5.33vw;
  }

  .rank-table-wrap .yesterday-rank-h .user-info {
    width: 32vw;
  }

  .rank-table-wrap .yesterday-rank-h .price {
    width: 37.33vw;
    text-align: center;
  }

  .rank-table-wrap .rank-index {
    width: 17.73vw;
    height: 8.27vw;
    line-height: 8.27vw;
    margin-right: 1.33vw;
  }

  .rank-table-wrap .rank-index .first-img {
    width: 17.73vw;
    height: 7.6vw;
  }

  .rank-table-wrap .rank-index .second-img,
  .rank-table-wrap .rank-index .third-img {
    width: 12.13vw;
    height: 7.6vw;
  }

  .rank-table-wrap .user-avatar {
    width: 6.4vw;
    height: 6.4vw;
    -webkit-border-radius: 3.2vw;
    border-radius: 3.2vw;
    position: relative;
    margin: -1.07vw 2.53vw 0.93vw 0vw;
  }

  .rank-table-wrap .user-avatar img {
    width: 6.4vw;
    height: 6.4vw;
    -webkit-border-radius: 3.2vw;
    border-radius: 3.2vw;
  }

  .rank-table-wrap .user-avatar .avatar-bg {
    width: 6.67vw;
    height: 6.67vw;
    overflow: hidden;
    background: url("../../assets/images/k22.png") no-repeat 0 0;
    background-size: 6.67vw 6.67vw;
    position: absolute;
    left: -1px;
    top: 6px;
    z-index: 5;
  }

  .rank-table-wrap .nickname {
    // width: 33vw;
    height: 8.8vw;
    line-height: 8.8vw;
    font-size: 3.33vw;
    text-align: left;
  }

  .rank-table-wrap .yesterday-rank-i .user-info {
    width: 52.4vw;
  }

  .rank-table-wrap .yesterday-rank-i .user-info .rank-index {
    width: 17.73vw;
  }

  .all-rank-dialog .rank-table-wrap .yesterday-rank-i .user-info .rank-index .second-img,
  .all-rank-dialog .rank-table-wrap .yesterday-rank-i .user-info .rank-index .third-img {
    margin: 0 2.8vw;
  }

  .all-rank-dialog .rank-table-wrap .yesterday-rank-i .user-info .rank-index div {
    width: 17.73vw;
  }

  .rank-table-wrap .yesterday-rank-i .user-info .user-avatar {
    margin-left: 2.67vw;
  }

  .rank-table-wrap .yesterday-rank-i .price {
    margin-left: 1.33vw;
    width: 37.73vw;
    line-height: 8.27vw;
    text-align: center;
    color: #ffe3c2;
  }

  .rank-table-wrap .rank-table-list .prod-price {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    height: 8.8vw;
    line-height: 8.8vw;
  }

  .explain-content {
    width: 91.47vw;
    height: 109.33vw;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    margin: 0 4.27vw;
    position: relative;
  }

  .explain-content .rank-table {
    width: 91.47vw;
    height: 93.33vw;
  }

  .explain-content .rank-table .table-head {
    width: 91.47vw;
    height: 5.33vw;
    background: url("../../assets/images/header-bg-2.png") no-repeat 0 0;
    background-size: 100%;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
    font-size: 3.33vw;
    font-weight: 700;
    text-align: center;
    line-height: 5.33vw;
    color: #a6bbff;
  }

  .explain-content .rank-table .table-head .head-index {
    height: 100%;
    width: 58%;
  }

  .explain-content .rank-table .table-head .head-price {
    height: 100%;
    width: 41%;
  }

  .explain-content .rank-table .table-body {
    width: 91.47vw;
    height: 88vw;
    overflow: hidden;
    overflow-y: scroll;
  }

  .explain-content .rank-table .table-body .table-item {
    width: 91.47vw;
    height: 9.73vw;
    line-height: 9.73vw;
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
  }

  .all-rank-dialog .explain-content .rank-table .table-body .table-item .item-index {
    height: 100%;
    width: 58%;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
  }

  .all-rank-dialog .explain-content .rank-table .table-body .table-item .item-index .index-icon {
    width: 17.73vw;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    margin-right: 2.67vw;
  }

  .all-rank-dialog .explain-content .rank-table .table-body .table-item .item-index .index-icon .first-img {
    width: 17.73vw;
    height: 7.6vw;
  }

  .all-rank-dialog .explain-content .rank-table .table-body .table-item .item-index .index-icon .second-img,
  .all-rank-dialog .explain-content .rank-table .table-body .table-item .item-index .index-icon .third-img {
    width: 12.13vw;
    height: 7.6vw;
  }

  .all-rank-dialog .explain-content .rank-table .table-body .table-item .item-index .index-icon .ranking {
    font-size: 2.67vw;
    font-family: Adobe Heiti Std, Adobe Heiti Std-R;
    font-weight: normal;
    color: #ffffff;
  }

  .all-rank-dialog .explain-content .rank-table .table-body .table-item .item-price {
    height: 100%;
    width: 41%;
    text-align: center;
    font-size: 2.67vw;
    font-family: Adobe Heiti Std, Adobe Heiti Std-R;
    font-weight: normal;
    color: #ffe3c2;
  }

  .explain-content .rank-table .table-body .table-item:after {
    content: "";
    display: block;
    width: 91.47vw;
    height: 0.4vw;
    background: url("../../assets/images/line16.png") no-repeat 0 0;
    background-size: 91.47vw 0.4vw;
    position: absolute;
    left: 0;
    bottom: 0;
  }

  .explain-content .rank-footer {
    padding-top: 2.67vw;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    width: 91.47vw;
    height: 17.33vw;
    font-size: 3.33vw;
    font-family: Adobe Heiti Std, Adobe Heiti Std-R;
    font-weight: normal;
    text-align: center;
    color: #ced0ff;
  }

  .cur-rank-box {
    width: 95.07vw;
    height: 11.33vw;
    background: url("../../assets/images/cur_rank_bg.png") no-repeat 0 0;
    background-size: 95.07vw 11.33vw;
    margin: 6.67vw 4.27vw 2.67vw;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
  }

  .cur-rank-box .rank-index {
    width: 14.67vw;
    height: 8.27vw;
    line-height: 8.27vw;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    text-align: center;
    margin-right: 1.33vw;
    font-size: 3.33vw;
  }

  .cur-rank-box .user-info {
    width: 38.67vw;
    height: 8.27vw;
    line-height: 8.27vw;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
  }

  .cur-rank-box .user-avatar {
    width: 6.4vw;
    height: 6.4vw;
    -webkit-border-radius: 3.2vw;
    border-radius: 3.2vw;
    position: relative;
    margin: 0.93vw 2.53vw 0.93vw 5.33vw;
  }

  .cur-rank-box .user-avatar img {
    width: 6.4vw;
    height: 6.4vw;
    -webkit-border-radius: 3.2vw;
    border-radius: 3.2vw;
  }

  .cur-rank-box .user-avatar .avatar-bg {
    width: 6.4vw;
    height: 6.4vw;
    overflow: hidden;
    background: url("../../assets/images/k22.png") no-repeat 0 0;
    background-size: 6.4vw 6.4vw;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 5;
  }

  .cur-rank-box .prod-price {
    width: 37.33vw;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    text-align: right;
    padding-right: 6.67vw;
    margin-left: 1.33vw;
  }

  .cur-rank-box .prod-price .tips {
    font-size: 2.67vw;
    font-family: Adobe Heiti Std, Adobe Heiti Std-R;
    font-weight: normal;
    color: #b3c6ff;
    white-space: nowrap;
  }

  .cur-rank-box .prod-price .price {
    font-size: 3.33vw;
    font-family: Adobe Heiti Std, Adobe Heiti Std-R;
    font-weight: normal;
    color: #ffe3c2;
  }

  .date-filter {
    width: 91.47vw;
    height: 9.87vw;
    margin: 0 4.27vw;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    position: relative;
  }

  .date-filter .filter-item {
    position: absolute;
    top: -1.33vw;
    z-index: 1;
    width: 28.13vw;
    height: 9.87vw;
    text-align: center;
    background: url("../../assets/images/filter_item_sel.png") no-repeat 0 center;
    background-size: 27.2vw 8.93vw;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    font-size: 4.4vw;
    font-weight: 700;
    color: #ffffff;
  }

  .date-filter .filter-item.active {
    background: url("../../assets/images/filter_item.png") no-repeat 0 center;
    background-size: 28.13vw 9.87vw;
  }

  .date-filter .filter-item image {
    width: 7.47vw;
    height: 4.13vw;
  }

  .date-filter .filter-item:nth-child(1) {
    left: 0;
  }

  .date-filter .filter-item:nth-child(3) {
    right: 0;
  }
}
</style>